import Vue from 'vue'
import Vuex from 'vuex'
import actions from './actions'
import mutations from './mutations.js'
import houseFilter from './modules/houseFilter'

Vue.use(Vuex)
const store = new Vuex.Store({
  state: {
    userInfo: null // 用户信息
  },
  actions,
  mutations,
  modules: {
    houseFilter
  }
})

export default store
